import { ToWords } from "to-words";
import { currencies } from "../utils/common";

export const MoneyFormat = (number, currency) =>
  new Intl.NumberFormat(currency ? currency : "en-IN").format(number);
// export const NewMoneyFormatv2 = (number, currency) => {
//   // console.log(number, "number");
//   // let value = e.target.value
//   // console.log(value)
//   // value = value.replace(/,/g, "")
//   // console.log(value)
//   // if (!(/^\d*(?:\.\d*)?$/).test(value)) {
//   //   console.log('first')
//   //   return
//   // }
//   if (number === "-") {
//     return number;
//   }
//   if (number === ".") {
//     return "0.";
//   }
//   // Treat 0 as valid; only empty string/null/undefined should return empty
//   if (number === "" || number === null || number === undefined) {
//     return "";
//   }
//   function hasTwoDecimalPlacesAndEndsWithZero(number) {
//     console.log(number, typeof number);
//     let numberInt = parseInt(number * 100);
//     const decimalPart = (numberInt % 100).toFixed(2); // Get the two decimal places

//     if (decimalPart == 0) {
//       return false;
//     }

//     if (
//       numberInt?.toString().length - number?.toString().length != -1 ||
//       number[0] == "0"
//     ) {
//       return false;
//     } else {
//       return true;
//     }
//     console.log(decimalPart);
//   }
//   if (!currency) {
//     currency = "en-IN";
//   }
//   if (typeof number === "string") {
//     if (number[number.length - 1] === ".")
//       return (
//         new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(
//           number
//         ) + "."
//       );
//     else if (
//       number[number.length - 1] === "0" &&
//       number[number.length - 2] === "."
//     )
//       return (
//         new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(
//           number
//         ) + ".0"
//       );
//   }
//   if (isNaN(number)) {
//     return "";
//   } else {
//     if (hasTwoDecimalPlacesAndEndsWithZero(number)) {
//       return new Intl.NumberFormat(currency, {
//         maximumFractionDigits: 2,
//         minimumFractionDigits: 2,
//       }).format(number);
//     } else {
//       return new Intl.NumberFormat(currency, {
//         maximumFractionDigits: 2,
//       }).format(number);
//     }
//   }
// };
//LEDX-5577
export const NewMoneyFormatv2 = (number, currency = "en-IN") => {
  if (number === "-" ) return number;
  if (number === ".") return "0.";
  if (number === "" || number === null || number === undefined) return "";

  // ✅ While typing, preserve raw decimal part (e.g., "0.20")
  if (typeof number === "string") {

    // Case: contains decimal and user hasn't finished typing
    if (/^\d+\.\d{0,2}$/.test(number)) {
      const [intPart, decPart] = number.split(".");
      const formattedInt = new Intl.NumberFormat(currency).format(Number(intPart || 0));
      return formattedInt + "." + decPart; // ✅ Preserve decimal input
    }

    // Case: ends with dot like "12."
    if (number.endsWith(".")) {
      return new Intl.NumberFormat(currency).format(Number(number)) + ".";
    }
  }

  if (isNaN(number)) return "";

  // ✅ Final display: max 2 decimals, show trailing zero if needed
  return new Intl.NumberFormat(currency, {
    maximumFractionDigits: 2,
    minimumFractionDigits: number % 1 === 0 ? 0 : 2,
  }).format(number);
};

export const MoneyFormatv2 = (number, currency) => {
  // let value = e.target.value
  // console.log(value)
  // value = value.replace(/,/g, "")
  // console.log(value)
  // if (!(/^\d*(?:\.\d*)?$/).test(value)) {
  //   console.log('first')
  //   return
  // }
  if (!currency) {
    currency = "en-IN";
  }
  if (typeof number === "string") {
    if (number[number.length - 1] === ".") return number;
    else if (
      number[number.length - 1] === "0" &&
      number[number.length - 2] === "."
    )
      return number;
  }
  if (isNaN(number)) {
    return 0;
  } else {
    return new Intl.NumberFormat(currency, { maximumFractionDigits: 2 }).format(
      number
    );
  }
};
export const QuantityFormat = (number, currency) => {
  // let value = e.target.value
  // console.log(value)
  // value = value.replace(/,/g, "")
  // console.log(value)
  // if (!(/^\d*(?:\.\d*)?$/).test(value)) {
  //   console.log('first')
  //   return
  // }
  if (!currency) {
    currency = "en-IN";
  }
  if (typeof number === "string") {
    if (number[number.length - 1] === ".") return number;
    else if (
      number[number.length - 1] === "0" &&
      number[number.length - 2] === "."
    )
      return number;
  }
  if (isNaN(number)) {
    return 0;
  } else {
    return new Intl.NumberFormat(currency, { maximumFractionDigits: 5 }).format(
      number
    );
  }
};
export const MoneyFormatv3 = (number, currency) => {
  if (isNaN(number)) {
    number = 0;
  }
  return new Intl.NumberFormat("en-IN", {
    // style: 'currency',
    // currency: currency,
    minimumFractionDigits: 2, // Minimum decimal places
    maximumFractionDigits: 2, // Maximum decimal places
  }).format(number);
};

export const MoneyFormatUniversal = (amount, options = {}) => {
  const { currency = "INR", compact = true, locale = "en-IN" } = options;

  if (isNaN(amount)) return amount;

  const absAmount = Math.abs(amount);

  // INTERNATIONAL FORMAT
  const currencySymbol = getCurrencySymbol(currency);

  if (compact) {
    if (absAmount >= 1e12) {
      return `${currencySymbol} ${(amount / 1e12).toFixed(2)}T`;
    } else {
      if (currency === "INR") {
        return `${currencySymbol} ${addIndianCommas(amount.toFixed(2))}`;
      }
      return `${currencySymbol} ${addCommas(amount.toFixed(2))}`;
    }
  } else {
    if (currency === "INR") {
      return `${currencySymbol} ${addIndianCommas(amount.toFixed(2))}`;
    }
    return `${currencySymbol} ${new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
    }).format(amount)}`;
  }
};

// Indian comma separator
function addIndianCommas(value) {
  const [integer, decimal] = value.split(".");
  const lastThree = integer.slice(-3);
  const otherNumbers = integer.slice(0, -3);
  const formattedOtherNumbers = otherNumbers.replace(
    /\B(?=(\d{2})+(?!\d))/g,
    ","
  );
  return otherNumbers
    ? formattedOtherNumbers + "," + lastThree + "." + decimal
    : lastThree + "." + decimal;
}

// Intl comma separator
function addCommas(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// Currency symbols map
function getCurrencySymbol(code) {
  const symbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    INR: "₹",
    JPY: "¥",
    CNY: "¥",
    AUD: "A$",
    CAD: "C$",
    AED: "د.إ",
    // Add more as needed
  };
  return symbols[code] || code + " ";
}

const getCurrencyUnit = ({ currency = "INR", unit, subunit }) => {
  return {
    unit:
      unit == 1 ? currencies[currency]?.unit : currencies[currency]?.unitPlural,
    subunit:
      subunit == 1
        ? currencies[currency]?.subunit
        : currencies[currency]?.subunitPlural,
  };
};

export const getWords = (sum, currency = "INR") => {
  try {
    if (typeof sum == NaN) {
      return "";
    }

    const toWords = new ToWords();
    let rupees = Math.floor(sum);
    let paisa = parseInt((sum - rupees).toFixed(2) * 100);
    console.log({ rupees, paisa, sum, j: (sum - rupees) * 100 });
    const { unit, subunit } = getCurrencyUnit({
      currency,
      unit: rupees,
      subunit: paisa,
    });
    const connector = subunit ? "And" : "Point";
    if (paisa > 0) {
      if (subunit) {
        return `${unit} ${toWords?.convert(
          rupees
        )}  ${connector} ${toWords?.convert(paisa)} ${subunit}`;
      } else {
        return `${toWords?.convert(rupees)} ${connector} ${toWords?.convert(
          paisa
        )} ${subunit}`;
      }
    } else {
      return `${unit} ${toWords?.convert(rupees)} `;
    }
  } catch (error) {
    console.log(error);
    return "";
  }
};
